export interface MetaEventsBody {
  pixel_id: string
  test_event_code?: string
  events: Array<Record<string, unknown>>
}

type UnixSeconds = number

export interface BuildMetaEventParams {
  pixelId: string
  eventName: 'Purchase' | 'CompleteRegistration'
  eventTime: UnixSeconds
  eventId?: string
  email?: string
  fbc?: string
  fbp?: string
  ipAddress?: string
  userAgent?: string
  customData?: Record<string, unknown>
  testEventCode?: string
  eventSourceUrl?: string
}

export const buildMetaEventsBody = (p: BuildMetaEventParams): MetaEventsBody => {
  const userData: Record<string, unknown> = {}
  if (p.email) userData.em = p.email
  if (p.fbc) userData.fbc = p.fbc
  if (p.fbp) userData.fbp = p.fbp
  if (p.userAgent) userData.client_user_agent = p.userAgent
  if (p.ipAddress) userData.client_ip_address = p.ipAddress

  const event: Record<string, unknown> = {
    event_name: p.eventName,
    event_time: p.eventTime,
    action_source: 'website',
    user_data: userData
  }
  if (p.eventId) event.event_id = p.eventId
  if (p.eventSourceUrl) event.event_source_url = p.eventSourceUrl
  if (p.customData) event.custom_data = p.customData

  const body: MetaEventsBody = { pixel_id: p.pixelId, events: [event] }
  if (p.testEventCode) body.test_event_code = p.testEventCode
  return body
}
